import api from './api';

const API_URL = process.env.REACT_APP_API_URL || '/api';
const getApiUrl = () => {
  const url = process.env.REACT_APP_API_URL || '/api';
  if (url.startsWith('http')) {
    return url.includes('/api') ? url : `${url}/api`;
  }
  return url;
};

// Upload using XMLHttpRequest (more reliable for file uploads)
const uploadWithXHR = (url, formData) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${getApiUrl()}${url}`);

    const token = localStorage.getItem('token');
    if (token) {
      xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    }
    // Let browser set Content-Type with boundary

    xhr.withCredentials = true;

    xhr.onload = () => {
      try {
        const data = JSON.parse(xhr.responseText);
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(data);
        } else {
          reject(new Error(data.error || 'Upload failed'));
        }
      } catch (e) {
        reject(new Error('Invalid response'));
      }
    };

    xhr.onerror = () => {
      reject(new Error('Network error'));
    };

    xhr.send(formData);
  });
};

export const userApi = {
  getUser: async (id) => {
    return await api.get(`/users/${id}`);
  },

  getUserByUsername: async (username) => {
    return await api.get(`/users/username/${username}`);
  },

  updateUser: async (id, data) => {
    return await api.put(`/users/${id}`, data);
  },

  uploadAvatar: async (id, file) => {
    const formData = new FormData();
    formData.append('avatar', file);
    // Use fetch to bypass axios issues
    return await uploadWithXHR(`/users/${id}/avatar`, formData);
  },

  search: async (query, limit = 20, offset = 0) => {
    return await api.get(`/users/search?q=${encodeURIComponent(query)}&limit=${limit}&offset=${offset}`);
  },

  searchFriends: async (query, limit = 20, offset = 0) => {
    return await api.get(`/users/friends/search?q=${encodeURIComponent(query)}&limit=${limit}&offset=${offset}`);
  },

  // Admin: Get all users with pagination and search
  getUsers: async (params = {}) => {
    const { limit = 20, offset = 0, search = '' } = params;
    return await api.get(`/admin/users?limit=${limit}&offset=${offset}&search=${encodeURIComponent(search)}`);
  },

  // Admin: Get user with groups
  getUserWithGroups: async (userId) => {
    return await api.get(`/admin/users/${userId}`);
  },

  // Admin: Activate user
  activateUser: async (userId) => {
    return await api.put(`/admin/users/${userId}/activate`);
  },

  // Admin: Suspend user
  suspendUser: async (userId) => {
    return await api.put(`/admin/users/${userId}/suspend`);
  },

  // Admin: Reset password
  resetPassword: async (userId, data) => {
    return await api.post(`/admin/users/${userId}/reset-password`, data);
  },

  // Admin: Force logout
  forceLogout: async (userId) => {
    return await api.post(`/admin/users/${userId}/logout`);
  },

  // Admin: Delete user
  deleteUser: async (userId) => {
    return await api.delete(`/admin/users/${userId}`);
  },
};
